"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDateToUserToShiftMap = makeDateToUserToShiftMap;
exports.repeatShiftsFromTemplate = repeatShiftsFromTemplate;
exports.mergeLinkedShifts = mergeLinkedShifts;
exports.initPlanFunctions = initPlanFunctions;
exports.makeComputedValuesMap = makeComputedValuesMap;
exports.newBranchFromRaw = newBranchFromRaw;
exports.newBranchStore = newBranchStore;
exports.newMeStore = newMeStore;
exports.newRoleStoreFromRaw = newRoleStoreFromRaw;
exports.newEmploymentStoreFromRaw = newEmploymentStoreFromRaw;
exports.calcTableStartDate = calcTableStartDate;
exports.calcTableEndDate = calcTableEndDate;
exports.calcViewType = calcViewType;
exports.getShiftAndOptionsForStats = getShiftAndOptionsForStats;
exports.calcShiftForShiftStoreFromRaw = calcShiftForShiftStoreFromRaw;
exports.calcRepeatShiftsFromRawTemplateForShiftStore = calcRepeatShiftsFromRawTemplateForShiftStore;
exports.newSummaryStats = newSummaryStats;
exports.addRawSlotToShiftStore = addRawSlotToShiftStore;
exports.getDateStringsForSlot = getDateStringsForSlot;
exports.buildCellsMap = buildCellsMap;
exports.addSlotToCellsMap = addSlotToCellsMap;
exports.renderRepeatSlots = renderRepeatSlots;
exports.computeRequestedVacationByUser = computeRequestedVacationByUser;
exports.computeMonthlyLaborFlags = computeMonthlyLaborFlags;
const luxon_1 = require("luxon");
const common_1 = require("../js/common");
const repeatShift_1 = require("../model/v1/repeatShift");
const section_1 = require("../model/v1/section");
const mergedShift_1 = require("../model/v1/mergedShift");
const common_2 = require("../common/common");
const apiClientImpl_1 = require("../webappApi/v2/apiClientImpl");
const plan_1 = require("../plan/v1/plan");
const branchStore_1 = require("../store/v1/branchStore");
const branchParser_1 = require("../legacy/parser/branchParser");
const branchSettingsParser_1 = require("../legacy/parser/branchSettingsParser");
const meStore_1 = require("../store/v1/meStore");
const user_1 = require("../model/v1/user");
const roleStore_1 = require("../store/v1/roleStore");
const roleParser_1 = require("../legacy/parser/roleParser");
const employmentStore_1 = require("../store/v1/employmentStore");
const employmentParser_1 = require("../legacy/parser/employmentParser");
const periodTypes_1 = __importDefault(require("../table/v1/periodTypes"));
const table_1 = require("../table/v1/table");
const viewTypes_1 = __importDefault(require("../table/v1/viewTypes"));
const shiftParser_1 = require("../legacy/parser/shiftParser");
const timeZones_1 = __importDefault(require("../common/timeZones"));
const employmentShiftTableStats_1 = require("./employmentShiftTableStats");
const models_1 = require("../js/models");
const webappApi = new apiClientImpl_1.ApiClientImpl();
function makeDateToUserToShiftMap(dates, shifts) {
    const dateToUserToSlots = {};
    dates.forEach(d => {
        dateToUserToSlots[d.index()] = {};
        const endDate = d.getEnd();
        shifts.forEach(s => {
            if (!(0, common_1.timespansOverlap)(s.getStartDate(), s.getEndDate(), d.getDate(), endDate)) {
                return;
            }
            if (!dateToUserToSlots[d.index()][s.getUserId()]) {
                dateToUserToSlots[d.index()][s.getUserId()] = {};
            }
            dateToUserToSlots[d.index()][s.getUserId()][s.index()] = s;
        });
    });
    return dateToUserToSlots;
}
function repeatShiftsFromTemplate(startDate, endDate, template, localTimeZone) {
    const out = [];
    const repeatStartInOriginalTz = luxon_1.DateTime.fromJSDate(template.getRepeatStart(), { zone: template.getTimeZone() }).set({ hour: template.getStartHour(), minute: template.getStartMinute() });
    const repeatStartInLocal = repeatStartInOriginalTz.setZone(localTimeZone);
    const repeatEndInOriginalTz = luxon_1.DateTime.fromJSDate(template.getRepeatEnd(), { zone: template.getTimeZone() }).set({ hour: template.getEndHour(), minute: template.getEndMinute() });
    const repeatEndInLocal = repeatEndInOriginalTz.setZone(localTimeZone);
    let start = repeatStartInLocal;
    if (start.valueOf() < startDate.valueOf()) {
        const s = luxon_1.DateTime.fromJSDate(startDate, { zone: localTimeZone });
        const weekdayDiff = ((start.weekday - s.weekday) + 7) % 7;
        start = s.plus({ day: weekdayDiff });
    }
    start = start.set({ hour: repeatStartInLocal.hour, minute: repeatStartInLocal.minute });
    let end = start.set({ hour: repeatEndInLocal.hour, minute: repeatEndInLocal.minute });
    if (end.valueOf() < start.valueOf()) {
        end = end.plus({ day: 1 });
    }
    let repeats = 1;
    // If template start and end overlap with dates
    while ((0, common_2.timespansOverlapIncl)(startDate, endDate, start.toJSDate(), end.toJSDate()) && (0, common_2.timespansOverlapIncl)(repeatStartInLocal.toJSDate(), repeatEndInLocal.toJSDate(), start.toJSDate(), end.toJSDate())) {
        let isIncluded = true;
        for (let i = 0; i < template.exclude.length; i++) {
            const d = template.exclude[i];
            const date = luxon_1.DateTime.fromJSDate(d, { zone: localTimeZone });
            const format = "yyyy MM dd";
            // If the same calendar date in local time, then excluded
            if (date.toFormat(format) == start.toFormat(format)) {
                isIncluded = false;
                break;
            }
        }
        if (isIncluded) {
            const feId = `${template.getOriginalId()}-${repeats}`;
            const options = {
                hideTo: template.isHideTo(),
                hideFrom: template.isHideFrom(),
                rest: template.getRest(),
                feId,
                roleId: template.getOriginalRoleId(),
                roleName: template.getRoleName(),
                purpose: template.getPurpose(),
                linkPrev: template.getLinkPrev(),
                linkNext: template.getLinkNext(),
                isEdited: template.getIsEdited(),
                wage: template.wage,
            };
            if (template.sections.length) {
                options.sections = [];
                for (const sTemplate of template.sections) {
                    const templateStart = luxon_1.DateTime.fromJSDate(sTemplate.getStartDate(), { zone: localTimeZone });
                    const templateEnd = luxon_1.DateTime.fromJSDate(sTemplate.getEndDate(), { zone: localTimeZone });
                    const sectionStart = start.set({ hour: templateStart.hour, minute: templateStart.minute });
                    const sectionEnd = start.set({ hour: templateEnd.hour, minute: templateEnd.minute });
                    if (sectionEnd.valueOf() < sectionStart.valueOf()) {
                        sectionEnd.plus({ day: 1 });
                    }
                    const required = {
                        id: sTemplate.getOriginalId(),
                        type: sTemplate.getType(),
                        branchId: template.branchId,
                        userId: template.userId,
                        startDate: sectionStart.toJSDate(),
                        endDate: sectionEnd.toJSDate(),
                    };
                    const shiftOptions = {
                        roleId: parseInt(sTemplate.getRoleId())
                    };
                    const section = new section_1.Section(repeats, required, shiftOptions);
                    options.sections.push(section);
                }
            }
            const required = {
                userId: template.userId,
                startDate: start.toJSDate(),
                endDate: end.toJSDate(),
                type: template.getType(),
                branchId: template.branchId,
                id: repeats,
            };
            const shift = new repeatShift_1.RepeatShift(template.getOriginalId(), required, options);
            out.push(shift);
            repeats++;
        }
        // Add 7 days to current date
        start = start.plus({ days: template.interval });
        end = end.plus({ days: template.interval });
    }
    return out;
}
function mergeLinkedShifts(morning, night) {
    const required = {
        id: night.getOriginalId(),
        branchId: night.getOriginalBranchId(),
        userId: night.getOriginalUserId(),
        type: night.getType(),
        startDate: night.getStartDate(),
        endDate: morning.getEndDate(),
    };
    const options = {
        rest: night.getRest() + morning.getRest(),
        hideTo: morning.isHideTo(),
        hideFrom: morning.isHideFrom(),
        sections: [],
        roleId: night.getOriginalRoleId() || undefined,
        feId: `${night.getId()}-${morning.getId()}`,
        wage: night.getWage(),
    };
    options.sections?.push(...morning.getSections());
    options.sections?.push(...night.getSections());
    const out = new mergedShift_1.MergedShift(night.getOriginalId(), morning.getOriginalId(), required, options);
    return out;
}
async function initPlanFunctions(tableDates, branch, functionStore, valueStore) {
    const startInclusive = tableDates[0].getDate();
    const endInclusive = tableDates[tableDates.length - 1].getEnd();
    // query functions
    try {
        const { data, pagination } = await webappApi.fetchPlanFunctions({
            branchId: branch.getOriginalId(),
            isDeleted: false,
            showInSummary: true,
        });
        data.forEach(p => {
            functionStore.add(p);
        });
    }
    catch (e) {
        if (e instanceof Error) {
            console.error(e.message);
        }
    }
    // For each function
    const planFunctions = functionStore.query({ branchId: branch.getId() });
    for await (const pf of planFunctions) {
        // Do not fetch plan values for legacy placeholders
        if (!pf.getOriginalId()) {
            continue;
        }
        const { data, pagination } = await webappApi.fetchPlanValues({
            functionId: pf.getOriginalId(),
            startDateGte: startInclusive,
            startDateLte: endInclusive,
        });
        data.forEach(v => {
            valueStore.add(v);
        });
    }
}
function makeComputedValuesMap(tableDates, toCompute, functionStore, valueStore) {
    const out = {};
    tableDates.forEach(td => {
        out[td.index()] = {};
        toCompute.forEach(pf => {
            const v = computeValue(pf, td, functionStore, valueStore);
            if (v === undefined) {
                return;
            }
            out[td.index()][pf.getId()] = v;
        });
    });
    return out;
}
function computeValue(pf, td, functionStore, valueStore) {
    if (pf.isAllowedDefaultFunction()) {
        const opts = {
            functionStore,
            valueStore,
            startDateGte: td.getDate(),
            endDateLte: td.getEnd(),
        };
        const { value, errors } = (0, plan_1.evaluatePlanFunction)(pf.getFunctionBody(), opts);
        if (errors.length) {
            return;
        }
        return value;
    }
    else {
        // Find plan value for given day
        const pvs = valueStore.query({
            variableId: pf.getId(),
            startDateEq: td.getDate(),
            endDateEq: td.getEnd(),
            periodLength: td.getEnd().valueOf() - td.getDate().valueOf(),
        });
        if (!pvs.length) {
            return;
        }
        return pvs[0].getNumValue();
    }
}
function newBranchFromRaw(rawBranch, rawSettings) {
    const branch = (0, branchParser_1.parseFromRaw)(rawBranch);
    const settings = (0, branchSettingsParser_1.parseFromRaw)(rawSettings);
    branch.setSettings(settings);
    return branch;
}
function newBranchStore(branch) {
    const branchStore = new branchStore_1.BranchStore();
    branchStore.add(branch);
    return branchStore;
}
function newMeStore(activeUserId, isLeader, activeBranchId) {
    const req = {
        id: activeUserId,
    };
    const user = new user_1.User(req);
    const meStore = new meStore_1.MeStore({ user }, {
        isLeader,
    });
    meStore.setActiveBranchId(activeBranchId.toString());
    return meStore;
}
function newRoleStoreFromRaw(rawRoles, orRolesMap) {
    const roleStore = new roleStore_1.RoleStore();
    rawRoles.forEach(raw => {
        // parse as main role
        if (orRolesMap?.mainRolesMap[raw.ID]) {
            const subs = orRolesMap.mainRolesMap[raw.ID];
            const mainRole = (0, roleParser_1.parseMainRoleFromRaw)(raw, subs);
            roleStore.add(mainRole);
            return;
        }
        // parse as sub role
        if (orRolesMap?.subRolesMap[raw.ID]) {
            const mainRoleId = orRolesMap.subRolesMap[raw.ID];
            const subRole = (0, roleParser_1.parseOrRoleFromRaw)(raw, mainRoleId);
            roleStore.add(subRole);
            return;
        }
        const role = (0, roleParser_1.parseFromRaw)(raw);
        roleStore.add(role);
    });
    return roleStore;
}
function newEmploymentStoreFromRaw(rawUsers, activeBranchId) {
    const employmentStore = new employmentStore_1.EmploymentStore();
    rawUsers.forEach(r => {
        const employment = (0, employmentParser_1.parseFromRaw)(r, activeBranchId);
        employmentStore.add(employment);
    });
    return employmentStore;
}
function calcTableStartDate(dateStr, localTimeZone, viewType, monthStart, weekStart) {
    // To work with oplus time DOM and query data, force date to always be JST.
    let startDate = luxon_1.DateTime.now().setZone(localTimeZone).toJSDate();
    startDate = (0, table_1.truncate)(startDate, periodTypes_1.default.DAY, localTimeZone);
    if (dateStr) {
        try {
            startDate = (0, common_2.dateFromString)(dateStr, localTimeZone);
            if (viewType === viewTypes_1.default.CUSTOM) {
                return startDate;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    try {
        startDate = (0, table_1.calcStartDate)(startDate, viewType, localTimeZone, { monthStart, weekStart });
    }
    catch (e) {
        console.error(e);
        // calcStartDate returns some error messages intended for users
        if (e instanceof Error && e.message === "開始日と終了日を選択してください。") {
            alert(e.message);
        }
    }
    return startDate;
}
function calcTableEndDate(endDateStr, localTimeZone, startDate, monthStart, viewType) {
    try {
        if (endDateStr) {
            return (0, common_2.dateFromString)(endDateStr, localTimeZone);
        }
        // Monthly or weekly
        return (0, table_1.calcEndDate)(startDate, viewType, localTimeZone, { monthStart });
    }
    catch (e) {
        // calcEndDate returns some error messages intended for users
        if (e instanceof Error && e.message === "開始日と終了日を選択してください。") {
            alert(e.message);
        }
        console.error(e);
        // Default to weekly if any errors
        return (0, table_1.calcEndDate)(startDate, viewTypes_1.default.WEEK, localTimeZone, { monthStart });
    }
}
function calcViewType(defaultView, hasEndDate, URLparam) {
    if (hasEndDate) {
        return viewTypes_1.default.CUSTOM;
    }
    if (URLparam === viewTypes_1.default.MONTH || URLparam === viewTypes_1.default.WEEK || URLparam === viewTypes_1.default.DAY || URLparam === viewTypes_1.default.YEAR || URLparam === viewTypes_1.default.CUSTOM) {
        return URLparam;
    }
    return defaultView;
}
function getShiftAndOptionsForStats(s, shiftStore, splitNightShift) {
    const options = {
        countAllPeriods: false,
        applyRestFieldToFirstPeriodOnly: false,
    };
    let shift = s;
    if (shift.isLinkedShift()) {
        let night, morning;
        if (shift.isMorningShift()) {
            morning = shift;
            night = shiftStore.byId(morning.getLinkedId());
        }
        else {
            night = shift;
            morning = shiftStore.byId(night.getLinkedId());
        }
        if (morning && night) {
            // Only calc stats for merged shift once, if both shift are in view.
            if (morning.getId() === shift.getId()) {
                return {
                    shift,
                    options,
                    doNotCalcStats: true,
                };
            }
            shift = mergeLinkedShifts(morning, night);
            options.countAllPeriods = true;
            options.applyRestFieldToFirstPeriodOnly = true;
        }
    }
    if (splitNightShift) {
        options.countAllPeriods = true;
    }
    return { shift, options, doNotCalcStats: false };
}
function calcShiftForShiftStoreFromRaw(rawSlot) {
    if (rawSlot.SectionParent || rawSlot.IsTemplate || rawSlot.Repeat) {
        return;
    }
    if (rawSlot.LinkPrev) {
        return (0, shiftParser_1.parseMorningShiftRaw)(rawSlot);
    }
    if (rawSlot.LinkNext) {
        return (0, shiftParser_1.parseNightShiftRaw)(rawSlot);
    }
    return (0, shiftParser_1.parseShiftRaw)(rawSlot);
}
function calcRepeatShiftsFromRawTemplateForShiftStore(rawSlot, repeatTimeZone, tableDates) {
    if (!rawSlot.Repeat) {
        return [];
    }
    const template = (0, shiftParser_1.parseRepeatShiftTemplateOplusTimeRaw)(rawSlot, repeatTimeZone);
    return repeatShiftsFromTemplate(tableDates[0].getDate(), tableDates[tableDates.length - 1].getEnd(), template, timeZones_1.default.ASIA_TOKYO);
}
// newSummaryStats will make a new summary stats class instance for weekly, monthly, or custom view
function newSummaryStats(roleStore, employmentStore, shiftStore, meStore, dates, settings, timeZone, useSectionWage) {
    const options = {
        onlyCountFirstPeriod: !settings.splitNightShift,
        onlyCountFirstRole: true,
        onlyCountFirstTransport: true,
        ignoreHideToLaborHours: true,
        useSectionWage: useSectionWage || false,
    };
    const summaryStats = new employmentShiftTableStats_1.EmploymentShiftTableStats(roleStore, employmentStore, shiftStore, meStore, dates, periodTypes_1.default.DAY, timeZone, options);
    return summaryStats;
}
// addRawSlotToShiftStore will take a raw slot, compute shift(s) as needed, and add it to the passed shift store.
function addRawSlotToShiftStore(rawSlot, repeatTimeZone, tableDates, shiftStore, activeBranchId) {
    if (rawSlot.SectionParent || rawSlot.IsTemplate) {
        return;
    }
    if (rawSlot.Repeat) {
        const repeatShifts = calcRepeatShiftsFromRawTemplateForShiftStore(rawSlot, repeatTimeZone, tableDates);
        repeatShifts.forEach(r => {
            if (r.isClone(activeBranchId.toString())) {
                return;
            }
            shiftStore.add(r);
        });
        return;
    }
    const shift = calcShiftForShiftStoreFromRaw(rawSlot);
    if (!shift) {
        return;
    }
    if (shift.isClone(activeBranchId.toString()) || shift.isShiftTemplate() || shift.isRepeatShiftTemplate()) {
        return;
    }
    shiftStore.add(shift);
}
// getDateStringsForSlot returns the equivalent of `slot.Date` (yyyy-MM-dd string in tz), but for each date it crosses instead of just the first.
function getDateStringsForSlot(rawSlot, tz, repeatDate) {
    const fromDate = (0, common_2.fromOplusTime)(new Date(rawSlot.From));
    const toDate = (0, common_2.fromOplusTime)(new Date(rawSlot.To));
    let fromDateTime = luxon_1.DateTime.fromJSDate(fromDate, { zone: tz });
    let toDateTime = luxon_1.DateTime.fromJSDate(toDate, { zone: tz });
    if (repeatDate) {
        const repeatFromDateTime = luxon_1.DateTime.fromJSDate(new Date(repeatDate), { zone: tz });
        let repeatToDateTime = repeatFromDateTime;
        // For Overnight repeat slots, we need to check repeat date to slot's end date if it crosses midnight
        if (!fromDateTime.hasSame(toDateTime, 'day')) {
            repeatToDateTime = repeatToDateTime.plus({ days: 1 });
        }
        fromDateTime = luxon_1.DateTime.fromObject({
            year: repeatFromDateTime.year,
            month: repeatFromDateTime.month,
            day: repeatFromDateTime.day,
            hour: fromDateTime.hour,
            minute: fromDateTime.minute,
            second: fromDateTime.second,
            millisecond: fromDateTime.millisecond
        }, {
            zone: tz
        });
        toDateTime = luxon_1.DateTime.fromObject({
            year: repeatToDateTime.year,
            month: repeatToDateTime.month,
            day: repeatToDateTime.day,
            hour: toDateTime.hour,
            minute: toDateTime.minute,
            second: toDateTime.second,
            millisecond: toDateTime.millisecond
        }, {
            zone: tz
        });
    }
    // Set slot's To value to next day if its a type 1 ~ 7 or HideTo is true, and its To value is the same as From
    // `slot.LinkNext && fromDateTime.day == toDateTime.day` part is for LinkNext, is to make sure LinkNext from and to have different date (seems an issue in the backend)
    if ((rawSlot.Type > 0 && fromDateTime.equals(toDateTime)) || rawSlot.HideTo || (rawSlot.LinkNext && fromDateTime.day == toDateTime.day)) {
        toDateTime = toDateTime.plus({ days: 1 });
    }
    // support of LinkNext, for older slots that has LinkNext, we only need the first date
    if (rawSlot.LinkNext) {
        toDateTime = fromDateTime.endOf('day');
    }
    const dates = [];
    let midnight = fromDateTime.startOf('day');
    while (midnight < toDateTime) {
        dates.push(midnight.toFormat('yyyy-MM-dd'));
        midnight = midnight.plus({ days: 1 });
    }
    return dates;
}
function buildCellsMap(cellsMap, slotMap, viewTo, lockedOnly, splitNightShift, tz) {
    for (const id in slotMap) {
        const slot = slotMap[id];
        if (slot.SectionParent || slot.IsTemplate) {
            continue;
        }
        else if (slot.Repeat) {
            renderRepeatSlots(cellsMap, slot, viewTo, lockedOnly, splitNightShift, tz);
        }
        else {
            addSlotToCellsMap(cellsMap, slot, splitNightShift, tz);
        }
    }
    ;
}
// Export required for summary_lib to export pass-through function for template.
function addSlotToCellsMap(cellsMap, s, splitNightShift, tz, repeatDate) {
    const dateStr = repeatDate ? (0, common_1.goDateString)(repeatDate) : s.Date;
    if (!cellsMap[s.UserID]) {
        cellsMap[s.UserID] = {};
        cellsMap[s.UserID][dateStr] = { slots: {} };
    }
    else if (!cellsMap[s.UserID][dateStr]) {
        cellsMap[s.UserID][dateStr] = { slots: {} };
    }
    cellsMap[s.UserID][dateStr].slots[s.ID] = {};
    if (!splitNightShift) {
        return;
    }
    // Add it to subsequent days as well, if it crosses midnight
    const dateStrings = getDateStringsForSlot(s, tz, repeatDate);
    dateStrings.forEach((dateString) => {
        if (!cellsMap[s.UserID][dateString]) {
            cellsMap[s.UserID][dateString] = { slots: {} };
        }
        cellsMap[s.UserID][dateString].slots[s.ID] = {};
    });
}
// Legacy, oplus time way of rendering repeat slots from the raw BE data view. Should consider replacing guts with repeatShiftsFromTemplate usage instead of extending this functionality.
// Export for testing only.
function renderRepeatSlots(cellsMap, slot, viewToIn, lockedOnly, splitNightShift, tz) {
    const repeatUntil = new Date(slot.RepeatUntil);
    const viewTo = new Date(viewToIn);
    viewTo.setUTCHours(23, 59, 59, 999); // WARNING: oplus time
    const curFrom = new Date(slot.From);
    curFrom.setUTCHours(curFrom.getUTCHours(), curFrom.getUTCMinutes(), curFrom.getUTCSeconds(), curFrom.getUTCMilliseconds()); // WARNING: oplus time
    const repeatExcludeMap = {};
    const repeatLockedMap = {};
    slot.RepeatExclude?.forEach(d => {
        repeatExcludeMap[(0, common_1.timestampFromDate)(d)] = true;
    });
    slot.RepeatLocked?.forEach(d => {
        repeatLockedMap[(0, common_1.timestampFromDate)(d)] = true;
    });
    do {
        const d = (0, common_1.timestampFromDate)(curFrom);
        if (!repeatExcludeMap[d]) {
            if (lockedOnly) {
                // if locked only, check repeatLockedMap
                if (repeatLockedMap[d]) {
                    addSlotToCellsMap(cellsMap, slot, splitNightShift, tz, new Date(d));
                }
            }
            else {
                // if not locked only, just add
                addSlotToCellsMap(cellsMap, slot, splitNightShift, tz, new Date(d));
            }
        }
        curFrom.setUTCDate(curFrom.getUTCDate() + 7);
    } while (curFrom <= viewTo && curFrom <= repeatUntil);
}
function computeRequestedVacationByUser(userIds, dates, slotData) {
    if (!dates?.length) {
        return new Map();
    }
    const monthStart = dates[0].getDate();
    const monthEnd = dates[dates.length - 1].getEnd();
    const requestedDaysByUser = new Map();
    for (const s of Object.values(slotData || {})) {
        const start = s.getStartDate();
        const end = s.getEndDate();
        if (!(0, common_2.timespansOverlapIncl)(start, end, monthStart, monthEnd)) {
            continue;
        }
        const slotType = s.getType();
        const createdBy = s.getCreatedBy();
        const userId = Number(s.getUserId());
        // Only count requested vacation created by the staff themselves
        if (slotType !== models_1.SLOT_TYPES.OFF_DAY && slotType !== models_1.SLOT_TYPES.PUBLIC_HOLIDAY && slotType !== models_1.SLOT_TYPES.OTHER_HOLIDAY) {
            continue;
        }
        if (createdBy !== userId) {
            continue;
        }
        let set = requestedDaysByUser.get(userId);
        if (!set) {
            set = new Set();
            requestedDaysByUser.set(userId, set);
        }
        // Add the day the staff requested off (prevent double counting if multiple requests are on the same day)
        const date = (0, common_2.yearMonthDateString)(start, timeZones_1.default.ASIA_TOKYO);
        set.add(date);
    }
    const result = new Map();
    for (const id of userIds) {
        result.set(id, requestedDaysByUser.get(id)?.size ?? 0);
    }
    return result;
}
// Compute the flags for monthly labor limit breaches
function computeMonthlyLaborFlags(limits, laborMinutes, requestedVacationCount) {
    const min = limits?.minMonthLaborMinutes || 0;
    const max = limits?.maxMonthLaborMinutes || 0;
    const vacationLimit = limits?.monthlyVacationLimit || 0;
    const underMinMonth = min > 0 ? laborMinutes < (min - 1) : false;
    const overMaxMonth = max > 0 ? laborMinutes > (max - 1) : false;
    const overMaxVacation = vacationLimit > 0 ? requestedVacationCount > vacationLimit : false;
    return { underMinMonth, overMaxMonth, overMaxVacation };
}
